import "../../App.css";
import React, { Component } from "react";
import { Button } from "react-bootstrap";
import { FaLink, FaMinusCircle } from "react-icons/fa";
import { CopyToClipboard } from "react-copy-to-clipboard";
import { VIEW_MODEL, HOST_URL } from "../../Constants";

class CardList extends Component {
  constructor(props) {
    super(props);

    this.handleClick = this.handleClick.bind(this);
    this.handleRemove = this.handleRemove.bind(this);
    this.handleShare = this.handleShare.bind(this);
  }

  handleShare() {
    this.props.shareFunc();
  }

  handleRemove(event) {
    this.props.removeFunc(event.currentTarget.getAttribute("_id"));
  }

  handleClick(item, event) {
    this.props.clickFunc(
      item.slug,
      item.name,
      item.meta_data,
      event
    );
  }
  render() {
    return (
      <div className="save-file-container">
        {this.props.fileList.map((item, iterator) => (
          <div className="save-file-list-block" key={iterator}>
            <div
              onClick={(e) => this.handleClick(item, e)}
              className="save-file-list-item"
            >
              <div className="save-file-name">{item.name}</div>
              <div>
                <CopyToClipboard
                  text={HOST_URL + VIEW_MODEL + item.slug}
                  onCopy={this.handleShare}
                >
                  <Button variant="light">
                    <FaLink />
                  </Button>
                </CopyToClipboard>
                <Button
                  _id={item.slug}
                  onClick={this.handleRemove}
                  variant="light"
                >
                  <FaMinusCircle />
                </Button>
              </div>
            </div>
          </div>
        ))}
      </div>
    );
  }
}

export default CardList;
